<template>
  <div class="mreceiveApp" :style="'min-height:'+curHeight+'px;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div>
      <p class="top">{{arr.timer == 0 ? '领取成功后，可获得一次买咖啡返现优惠。' : (arr.status==2 ? '申请时间 '+arr.timer+'，请耐心等待审批哦！' : arr.status == 1 ? '到期时间 '+arr.timer+'，恭喜您买咖啡返现机会哦！' : '')}}</p>
      <div class="conre">
        <div>
          <span>返现额度：</span>
          <b><font>￥</font>{{arr.rebate}}</b>
        </div>
        <div v-if="arr.rule == 1">
          <span>房间号：</span>
          <input v-if="arr.roomnumber == 0" type="text" v-model="roomnumber" placeholder="请输入房间号" />
          <input v-if="arr.roomnumber != 0" type="text" placeholder="请输入房间号" :value="arr.roomnumber" disabled />
        </div>
        <div v-if="arr.rule == 2">
          <span>认领码：</span>
          <input v-if="arr.roomnumber == 0" type="text" v-model="roomnumber" placeholder="请输入认领码" />
          <input v-if="arr.roomnumber != 0" type="text" placeholder="请输入认领码" :value="arr.roomnumber" disabled />
        </div>
        <div style="margin-top:30px">
          <button v-if="arr.timer == 0" @click="receice">申请领取</button>
          <button v-if="arr.timer != 0" style="background:#ddd;color:#666;">{{arr.status == 2 ? '申请中' : '已审核通过'}}</button>
        </div>
        <div style="height:80px">
        <p>注：已到账微信零钱<font style="color:red">{{arr.money}}</font>元</p>
        <p v-if="arr.rule == 1">注：申请领取买咖啡返现优惠，客服最快一小时内审批，请耐心等待!</p>
        <p v-if="arr.rule > 2">注：申请领取买咖啡返现优惠，无须审批，即可使用!</p>
        </div>
      </div>
      <!--<p class="title"></p>
      <h2><font>￥</font>{{arr.rebate}}</h2>
      <button v-if="arr.timer == 0" @click="receice">领取</button>
      <button v-if="arr.timer != 0" style="background:#ddd;color:#666;">已领取</button>-->
    </div>

    <div class="cashlist" v-if="total > 0">
      <h3>领取记录({{udried.length}})</h3>
      <ul>
        <li v-for="(item,i) in udried">
          <img class="tx" src="~assets/images/mrtx.jpg"/>
          <div class="username">
            <span>返现领取</span>
            <font>{{item.createtime}}</font>
          </div>
          <div class="timer">
            <span>{{arr.rebate}}元</span>
            <font>{{item.status == 1 ? '已领取' : '申请中'}}</font>
          </div>
        </li>
      </ul>
    </div>
    <div style="height:90px"></div>
    <div class="mrfooter">
      <span @click="$router.push('follow')">关注公众号</span><span @click="$router.push('mine')">个人中心</span>
      <p>本服务由职工生活家公众号提供</p>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: true,
        baseUrl:'',
        arr:[],
        udried:[],
        total:0,
        code:'',
        roomnumber:''
      };
    },
    created(){
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var id = this.$route.query.id;
          var url = encodeURIComponent('http://user.4008005216.com/main/mreceive?id='+id);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }else{
        this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
      }
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
      this.getDetail();
      this.getUserDried();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      receice:function(){
        var id = this.$route.query.id;
        var that = this;
        var rule = that.arr.rule
        if(rule == 1){
          if(that.roomnumber == ''){
            that.$alert('请输入房间号！', '提示', {
              confirmButtonText: '确定'
            });
            return false;
          }
        }

        if(rule == 2){
          if(that.roomnumber == ''){
            that.$alert('请输入认领码！', '提示', {
              confirmButtonText: '确定'
            });
            return false;
          }
        }
        
        that.fullscreenLoading = true;
        this.axios({
          method:'post',
          url:that.$host+'home/crowd/dried1',
          params:{
            user_id:that.userData.id,
            id:id,
            roomnumber:that.roomnumber
          }
        }).then(function(response){
          var res = response.data;
          if(response.data.status == 200){
            that.$alert(response.data.message, '提示', {
              confirmButtonText: '确定'
            });
            that.getDetail();
            that.getUserDried();
          }else{
            that.$alert(response.data.message, '提示', {
              confirmButtonText: '确定'
            });
          }
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
      getDetail:function(e){
        var that = this;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/crowd/getDried',
          params:{
            user_id:that.userData.id,
            id:id
          }
        }).then(function(response){
          var res = response.data;
          that.arr = res.data;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
      getUserDried:function(e){
        var that = this;
        this.axios({
          method:'post',
          url:that.$host+'home/crowd/userDried',
          params:{
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data;
          that.udried = res.data;
          that.total = res.data.length;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
          that.userData = res.data;
          that.getDetail();
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:80%;
  }
  .mreceiveApp{
    background:#fff;
  }
  .mreceiveApp .top{
    height:50px;
    line-height:50px;
    background:rgb(250,250,250);
    font-size:14px;
    text-align:center;
    color:#333
  }
  .conre{
    width:92%;
    margin:0 auto;
    padding-top:30px;
  }
  .conre div{
    height:50px;
  }
  .conre div span{
    float:left;
    font-size:15px;
    color:#666;
    width:25%;
    line-height:50px;
    text-align:right;
  }
  .conre div b{
    float:left;
    width:60%;
    line-height:50px;
    color:#f00;
    font-size:22px;
  }
  .conre div b font{
    font-size:13px;
    position:relative;
    top:-3px;
    padding-right:1px
  }

  .conre div input{
    float:left;
    width:60%;
    height:36px;
    line-height:36px;
    border:none;
    background:#ececec;
    border-radius:5px;
    color:#000;
    font-size:16px;
    margin-top:7px;
    outline:none;
    padding:0 8px;
  }
  .mreceiveApp .conre div button{
    width:90%;
    height:45px;
    line-height:45px;
    border:0;
    background:rgb(254,208,71);
    font-size:15px;
    font-weight:bold;
    border-radius:5px;
    display:block;
    margin:0 auto;
    letter-spacing:2px
  }
  .mreceiveApp .conre div p{
    font-size:12px;
    color:#666;
    width:90%;
    margin:0 auto;
    letter-spacing:1px;
    padding-top:8px;
    text-align:justify;
    line-height:18px
  }

  .mreceiveApp .mrfooter{
    position: fixed;
    bottom:0px;
    left:0;
    width:100%;
    text-align:center;
    background:#fff;
    padding:10px 0 20px 0;
  }
  .mreceiveApp .mrfooter span{
    font-size:14px;
  }
  .mreceiveApp .mrfooter span:first-child{
    padding-right:30px;
    position:relative;
  }
  .mreceiveApp .mrfooter span:first-child:after{
    position:absolute;
    content:'';
    width:1px;
    height:12px;
    background:#ccc;
    right:15px;
    top:2px;
  }
  .mreceiveApp .mrfooter p{
    font-size:14px;
    padding-top:10px;
    color:#666
  }

  .mreceiveApp .cashlist{
    width:92%;
    margin:0 auto;
  }
  .mreceiveApp .cashlist h3{
    font-size:16px;
    padding:15px 0
  }
  .mreceiveApp .cashlist ul{
    background:#f1f1f1;
    width: 100%;
    border-radius:5px;
  }
  .mreceiveApp .cashlist li{
    height: 50px;
    width: 94%;
    margin:0 auto;
    border-bottom: solid 1px #f6f6f6;
    padding-top:10px
  }
  .mreceiveApp .cashlist li:last-child{
    border-bottom:none;
  }
  .mreceiveApp .cashlist li img{
    float: left;
    width: 40px;
    border-radius: 50%;
  }
  .mreceiveApp .cashlist li .username{
    float: left;
    margin-left:10px
  }
  .mreceiveApp .cashlist li .username font{
    display: block;
    font-size: 12px;
    color: #666;
  }
  .cashlist li .username span{
    display: block;
    font-size: 15px;
    color: #000;
    padding-bottom:3px
  }
  .mreceiveApp .cashlist li .timer{
    float: right;
  }

  .mreceiveApp .cashlist li .timer font{
    display: block;
    font-size: 12px;
    color: #666;
    text-align: right
  }
  .cashlist li .timer span{
    display: block;
    font-size: 15px;
    color: #000;
    text-align: right;
    font-weight: bold;
    padding-bottom:3px
  }
</style>